import { render, staticRenderFns } from "./RicohReturnMail.vue?vue&type=template&id=e9599812&scoped=true&"
import script from "./RicohReturnMail.vue?vue&type=script&lang=js&"
export * from "./RicohReturnMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9599812",
  null
  
)

export default component.exports